import { Api } from 'utils';

class InformationService {
	
	static get = async (params?: any) => Api.createResponse('client/information',params);
	static save = async (params?: any) => Api.createResponse('client/information/save',params);
	static delete = async (params?: any) => Api.createResponse('client/information/delete',params);
	static updateCompanyData = async (params?: any) => Api.createResponse('client/information/update-company-data',params);
	static updateAgentData = async (params?: any) => Api.createResponse('client/information/update-agent-data',params);
	static saveRetargeting = async (params?: any) => Api.createResponse('client/information/retargeting',params);
	static saveHumanRedirect = async (params?: any) => Api.createResponse('client/information/human-redirect',params);
	static getData = async (params?: any) => Api.createResponse('client/information/data',params);

}

export default InformationService;